import {DomainAncestor, entityConfig} from "../../common/domain/DomainAncestor";
import {observable} from "mobx";
import {LovItem} from "../../metamodel/mdEntity";
import {IDomainObject} from "../../form/formUtils";
import {formatId} from "../../common/utils/utils";
import {EditableTenantAncestor} from "../../common/domain/EditableTenantAncestor";

@entityConfig()
export class ParamTable extends EditableTenantAncestor {

  @observable paramKey: LovItem;
  @observable tenantId: number;
  @observable value: string;

  constructor(json: IDomainObject) {
    super(json);

  }

  getFlattenId(): string {
    return (this.paramKey && (this.tenantId || this.tenantId === 0)) ? formatId(this.paramKey.label, this.tenantId) : null;
  }

}



// WEBPACK FOOTER //
// ./src/core/tenant/domain/tenantDomain.ts